import { PropType } from "vue";
import { PopProps } from "./type";

export default {
  contentStyle: Object as PropType<PopProps["contentStyle"]>,
  contentClass: [String, Array] as PropType<PopProps["contentClass"]>,
  modelValue: Boolean,
};
